import React from 'react';
import { cn } from '../../utils/cn';

export function DescriptionList({ orientation = 'horizontal', items = [], className }) {
  if (orientation === 'horizontal') {
    return (
      <dl className={cn('divide-y divide-border', className)}>
        {items.map((it, i) => (
          <div key={i} className="grid grid-cols-3 gap-4 py-2.5">
            <dt className="text-xs uppercase tracking-wider text-mute font-mono">{it.term}</dt>
            <dd className="col-span-2 text-sm text-text">{it.description}</dd>
          </div>
        ))}
      </dl>
    );
  }
  return (
    <dl className={cn('space-y-3', className)}>
      {items.map((it, i) => (
        <div key={i}>
          <dt className="text-xs uppercase tracking-wider text-mute font-mono mb-0.5">{it.term}</dt>
          <dd className="text-sm text-text">{it.description}</dd>
        </div>
      ))}
    </dl>
  );
}

export default DescriptionList;
